import React from 'react';
import './scss/skill.css';
import { HeaderText } from '../../styledcomponents/HeaderText/HeaderText'
import { SectionHeader } from '../../styledcomponents/SectionHeader/SectionHeader'

import { SkillCard } from '../../styledcomponents/SkillCard/index'

import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';


import iconSet from "../../icons/selection.json";
import IcomoonReact, { iconList } from "icomoon-react";


const Skill = (props) => {

    return (
        <div className="skill" id = "service">
            <div className="skill__container">


                <SectionHeader>My Skills</SectionHeader>
              

                <div className="skill__grid">
                    
                <input className = "skill__checkbox" type="checkbox" name="skill__checkbox" id="skill__check"/>
                <label  className = "skill__label"  htmlFor="skill__check">
                    
                    <span className = "skill__more">See More</span>
                    <span className = "skill__less">See Less</span>

                    
                </label>
                <div className="d">
                        <SkillCard
                        iconname = "angular"
                        rating = {85}
                        language = "Angular"
                        />
                    </div>

                    <div className="d">
                        <SkillCard
                        iconname = "react"
                        rating = {85}
                        language = "React"
                        />
                    </div>
                    <div className="d">
                    <SkillCard
                        iconname = "typescript"
                        rating = {80}
                        language = "Typescript"
                        />
                    </div>
                    <div className="d">
                    <SkillCard
                        iconname = "javascript"
                        rating = {80}
                        language = "Javascript"
                        />
                    </div>
                    <div className="d">
                    <SkillCard
                        iconname = "html-five"
                        rating = {90}
                        language = "HTML"
                        />
                    </div>
                    <div className="t">
                    <SkillCard
                        iconname = "sass"
                        rating = {75}
                        language = "Sass"
                        />
                    </div>
                    <div className="t">
                    <SkillCard
                        iconname = "android"
                        rating =  {70}
                        language = "Android"
                        />
                    </div>
                    <div className="t">
                    <SkillCard
                        iconname = "java"
                        rating = {60}
                        language = "Java"
                        />

                       
                    </div>
                    
                </div>

                
            </div>
        </div>
    )
}

export default Skill